import { render, staticRenderFns } from "./ManageTemplate.vue?vue&type=template&id=bb1fd03e&scoped=true"
import script from "./ManageTemplate.vue?vue&type=script&lang=js"
export * from "./ManageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1fd03e",
  null
  
)

export default component.exports